import { useQuery } from '@apollo/client';
import { useAccount } from '@bnnvara/accounts';
import getConfig from 'next/config';
import { useEffect, useRef, useState } from 'react';

import { FetchSignature } from '../../api/queries/me/notifications.gql';
import {
  WS_STATUS,
  connectToWebsocket,
} from '../../helpers/connectToWebsocket';

export function useNotificationsWebsocket() {
  const [latestMessage, setLatestMessage] = useState(null);
  const [websocketStatus, setWebsocketStatus] = useState(WS_STATUS.IDLE);
  const websocket = useRef(null);
  const {
    token,
    profile: { UID },
  } = useAccount();
  const {
    publicRuntimeConfig: {
      notifications: { websocketUrl },
    },
  } = getConfig();
  const { data } = useQuery(FetchSignature, {
    variables: {
      token,
      type: 'lambdaNotifications',
    },
    fetchPolicy: 'network-only',
    skip: !token,
  });

  /**
   * This useEffect sets the url for the websocket connection.
   */
  useEffect(() => {
    if (!UID || !websocketUrl) {
      return;
    }

    if (data?.me?.signature) {
      websocket.current = connectToWebsocket({
        serverLocation: `${websocketUrl}?userId=${UID}&hash=${data.me.signature}`,
        setStatus: setWebsocketStatus,
        setLatestMessage,
      });
    }
  }, [websocketUrl, UID, data]);

  /**
   * When we loose connection with the server,
   * an attempt to reconnect is being made every 5 seconds.
   */
  useEffect(() => {
    let timer;

    if (websocket.current && websocketStatus === WS_STATUS.CLOSED) {
      timer = setInterval(() => {
        websocket.current.reconnect();
      }, 5000);
    }
    // eslint-disable-next-line
    return () => clearInterval(timer);
  }, [websocketStatus]);

  return latestMessage;
}
